import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import VideoCardPoster from "/components/Video/VideoCardPoster";
import VideoCardParts from '/components/Video/VideoCardParts';
import ResultItems from "/components/resultItems";

const styles = theme => ({
    itemContainer: {
        padding: '20px 0px 20px'
    },
    customDivider: {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',   
    },
});

class TagAllItem extends Component {
    render() {
        const { item, classes } = this.props;
        let poster = item.media_id ? this.props.width === 'xs' ? item.posters.video_section_teaser : item.posters.thumb : null;
        const tvTypeIndex = item.categories && item.categories.findIndex((category) => category.type === 'TV')
        const routeName = tvTypeIndex >= 0 ? 'tvDetail' : 'videoDetail';

        return (
            item.media_id ?
            <React.Fragment>
                <Grid container
                direction="row"
                justify="center"
                alignItems="center" className={classes.itemContainer} spacing={16}>
                    <Grid xs={12} md={12} lg={6} item>  
                    <VideoCardPoster 
                        routeName={routeName}
                        item={item} 
                        videoPoster={poster} 
                        videoImgHeight={ this.props.width === 'xs' ? 100 : 90 } 
                    />
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                        <VideoCardParts 
                            routeName={routeName}
                            item={item} 
                            color='#000'  
                        />
                    </Grid>
                </Grid>
                <Divider className={classes.customDivider} />
            </React.Fragment>
            :
            <ResultItems item={item} />
        );
    }
}



export default withStyles(styles)(TagAllItem);
